__turbopack_context__.v({
  "addedToCartWrapper": "buying-options-module__BMXxLG__addedToCartWrapper",
  "buyingOption": "buying-options-module__BMXxLG__buyingOption",
  "buyingOptionCheckbox": "buying-options-module__BMXxLG__buyingOptionCheckbox",
  "buyingOptionContactSales": "buying-options-module__BMXxLG__buyingOptionContactSales",
  "buyingOptionLabel": "buying-options-module__BMXxLG__buyingOptionLabel",
  "buyingOptionParts": "buying-options-module__BMXxLG__buyingOptionParts",
  "buyingOptionPricing": "buying-options-module__BMXxLG__buyingOptionPricing",
  "buyingOptionSelected": "buying-options-module__BMXxLG__buyingOptionSelected",
  "contactMessage": "buying-options-module__BMXxLG__contactMessage",
  "optionPrice": "buying-options-module__BMXxLG__optionPrice",
  "optionUnitPrice": "buying-options-module__BMXxLG__optionUnitPrice",
  "quantityContainer": "buying-options-module__BMXxLG__quantityContainer",
});
